import { ClientPolicyDtoV2 } from '@core/pages/new-business-register/api'

export class ClientPolicyV2 implements ClientPolicyDtoV2 {
  supervisorOid: any;
  pky?: string;
  oid: string;
  ctm: any;
  clientOid: string;
  adviserOid: string;
  introducerOid: any;
  introducerPct: any;
  introducerIfam: any;
  servicingOid: any;
  servicingPct: any;
  servicingIfam: any;
  vestingOid: any;
  vestingPct: any;
  vestingIfam: any;
  ownersOid: any;
  ownersName: any;
  ownersNric: any;
  insuredTitle: any;
  insuredName: any;
  insuredNric: any;
  insuredTitleTwo: any;
  insuredNameTwo: any;
  insuredNricTwo: any;
  productOid: any;
  name: any;
  productTypeDetailed: any;
  productCategory: any;
  taggedKyc: any;
  type: any;
  policyNumber: any;
  businessId: any;
  principal: any;
  status: any;
  applicationDate: any;
  opsApprovalDate: any;
  approvedDate: any;
  startDate: any;
  endDate: any;
  bscClawbackStatus: any;
  bscClawbackAmount: any;
  clientRebateStatus: any;
  clientRebateAmount: any;
  clientAiStatus: any;
  productMetadata: any;
  creationType: any;
  faceToFace: any;
  faceToFaceSpecified: any;
  policyProfileRemarks: any;
  level1ComOid: any;
  level2ComOid: any;
  level3ComOid: any;
  level4ComOid: any;
  level1ComPct: any;
  level2ComPct: any;
  level3ComPct: any;
  level4ComPct: any;
  groupId: string;
  unitName: any;
  branchName: any;
  clusterName: any;
  mainInvestmentNbr: any;
  mainNbrOid: any;
}
